import { createSlice } from "@reduxjs/toolkit";
import { branchlist, submitComplaint ,complaintTracking} from "../api/Complaint";


const initialState = {
    isLoadingSubmit : false,
    isLoadingTrack: false,
    tracking:[],
    submit:[],
    branches:[]
}
export const ComplaintSlice = createSlice({
    name:'complaint',
    initialState,
    reducers:{
        removeResult:(state)=>{
            state.tracking = []
        },
    },
    extraReducers:{
        [submitComplaint.pending]:(state,{payload}) =>{
            return {
                ...state,
                isLoadingSubmit :true,
                submit : []
            }
        },
        [submitComplaint.fulfilled]:(state,{payload}) =>{
            return {
                ...state,
                isLoadingSubmit :false,
                submit : payload
            }
        },
        [complaintTracking.pending]:(state,{payload}) =>{
            return {
                ...state,
                isLoadingTrack :true,
                tracking : []
            }
        },
        [complaintTracking.fulfilled]:(state,{payload}) =>{
            return {
                ...state,
                isLoadingTrack :false,
                tracking : payload
            }
        },
        [branchlist.fulfilled]:(state,{payload}) =>{
            return {
                ...state,
                isLoadingSubmit :false,
                branches : payload
            }
        },
    }
})

export const {removeResult} = ComplaintSlice.actions
export default ComplaintSlice.reducer